export default function Theme(theme) {
    return {
        token: {
            colorPrimary: "#BD8136",
            borderRadius: "2px"
        },
        components: {
            Select: {
                multipleItemBg: "#f7f7f7"
            },
            Menu: {
                itemBg: 'white',
                itemSelectedBg: "#BD8136",
                itemSelectedColor: "white",
                itemBorderRadius: "0px",
                groupTitleFontSize: "25px",
                activeBarBorderWidth: "20px",
            },
            Layout: {
                triggerBg: '#BD8136',
            },
            Table: {
                headerBg: "#f9f9f9",
                headerBorderRadius: "0px"
            },
            Switch: {
                handleBg: "white"
            }

        },
      }
}